import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20sports%20stadium%20panorama%20with%20dramatic%20golden%20sunset%20lighting%2C%20massive%20packed%20arena%20with%20thousands%20of%20fans%2C%20athletic%20energy%20and%20excitement%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20golden%20and%20amber%20tones%2C%20atmospheric%20haze%20with%20stadium%20floodlights%2C%20epic%20scale%20and%20grandeur%2C%20professional%20sports%20photography&width=1800&height=1200&seq=hero-bb-sports&orientation=landscape"
          alt="bb体育 - 全球顶级体育竞技平台"
          className="w-full h-full object-cover object-top"
          title="bb体育官方体育竞技平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs md:text-sm font-label font-semibold tracking-wide backdrop-blur-sm">
            全球顶级体育竞技娱乐平台
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight tracking-tight">
          汇聚全球顶级赛事
          <br />
          <span className="text-primary-300">极速体验 一触即发</span>
        </h1>

        <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          bb体育为您提供覆盖全球30+体育项目的赛事投注、实时赛况直播和专业数据分析服务。
          安全稳定的平台保障，注册即享多重优惠福利，立即加入开启精彩体育之旅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 text-sm md:text-base font-label font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            立即注册
          </Link>
          <Link
            to="/category/football"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/10 text-white backdrop-blur-sm border border-white/20 text-sm md:text-base font-label font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看赛事
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mt-14">
          {[
            { value: '30+', label: '体育项目' },
            { value: '50,000+', label: '月均赛事' },
            { value: '500万+', label: '活跃用户' },
            { value: '99.9%', label: '平台稳定率' },
          ].map((stat, idx) => (
            <div key={idx} className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white mb-1">{stat.value}</p>
              <p className="text-xs md:text-sm text-white/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-8 h-12 rounded-full border-2 border-white/30 flex items-start justify-center pt-2 animate-bounce">
          <div className="w-1.5 h-3 rounded-full bg-white/60"></div>
        </div>
      </div>
    </section>
  );
}